export interface TenantReeferMaxUnpluggedTimeFormProfile {
  id?: number
  reeferContainerMaxUnpluggedTime?: number | null
}

export const defaultValues: TenantReeferMaxUnpluggedTimeFormProfile = {
  reeferContainerMaxUnpluggedTime: null,
}
